<template>
  <div class="el-date-editor el-range-editor el-input__inner el-date-editor--daterange el-range-editor--small">
    <input
      autocomplete="off"
      placeholder="起始值"
      v-model="startValue"
      @input="startInput"
      @change="startChange"
      class="el-range-input"/>
    <span class="el-range-separator">-</span>
    <input
      autocomplete="off"
      placeholder="截至值"
      v-model="endValue"
      @input="endInput"
      @change="endChange"
      class="el-range-input"/>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Array,
    dataType: {
      type: String,
      default: 'number'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  data () {
    return {
      startValue: null,
      endValue: null
    }
  },
  watch: {
    value: {
      deep: true,
      handler: function(value) {
        if (value) {
          this.val = value
        } else {
          this.startValue = null;
          this.endValue = null;
        }
      }
    }
  },
  methods: {
    startInput (e) {
      this.startValue = this.replaceData(e.target.value);
    },
    endInput (e) {
      this.endValue = this.replaceData(e.target.value);
    },
    startChange (e) {
      this.startValue = e.target.value;
      this.$emit('change', [this.startValue, this.endValue]);
    },
    endChange (e) {
      this.endValue = e.target.value;
      this.$emit('change', [this.startValue, this.endValue]);
    },
    replaceData (val) {
      if (this.dataType == 'number') {
        return val && val.replace(/[^\d.]/g, '');
      } else if (this.dataType == 'money') {
        return val && val.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '');
      }
      return val;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/business/NumberRange.vue